import script from "./CatalogModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CatalogModal.vue?vue&type=script&setup=true&lang=js"

import "./CatalogModal.vue?vue&type=style&index=0&id=212dbb64&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-212dbb64"]])

export default __exports__